import StepCard from "./components/StepCard";
import sendInvoiceImg from "../../../assets/img/apponboarding/send_invoice.png";

const StepSendInvoice = ({ onCtaClick, onSkip, stepNumber, selectedOrganization }) => {
  const isOperation = selectedOrganization?.type === "operation";
  return (
    <StepCard
      stepLabel={`Step ${stepNumber}`}
      title="Send an Invoice"
      description="Generate and send a professional invoice to your customer directly from the app."
      ctaLabel="Send Invoice"
      onCtaClick={onCtaClick}
      onSkip={onSkip}
      mediaSrc={null}
      selectedOrganization={selectedOrganization}
      backgroundColor="#EDF8FE"
      backgroundImage={sendInvoiceImg}
      videoUrl="https://youtu.be/eyJdafRGmSs"
    />
  );
};

export default StepSendInvoice;
